import { withTranslation } from "react-i18next";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
  TypesContext,
  CompletionsContext,
  ThemeContext,
  LoadingContext,
  ContactIdContext,
} from "../../App";
import { MsalInstanceContext, VariablesContext } from "../../auth/AppProvider";

import { useParams, useSearchParams } from "react-router-dom/dist";
import { CheckIcon, LockClosedIcon } from "@heroicons/react/24/solid";
import { initCompletion, getHistory } from "../../utils/requests/completions";

function FormHomePage({ t }) {
  const [completion, setCompletion] = useState({});
  let navigate = useNavigate();
  const [types] = useContext(TypesContext);
  const [isVisible, setIsVisible] = useState(false);

  let { id, checkoutid, returnpaiement } = useParams();
  const [searchParams] = useSearchParams();

  const [completions, setCompletions] = useContext(CompletionsContext);
  const msalInstance = useContext(MsalInstanceContext);
  const theme = useContext(ThemeContext);
  const variables = useContext(VariablesContext);
  const [, setLoading] = useContext(LoadingContext);
  const [propertiesParameters, setPropertiesParameters] = useState([]);
  const contactId = useContext(ContactIdContext);
  const [activityHistory, setActivityHistory] = useState([]);

  useEffect(() => {
    setIsVisible(false);
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 250);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    var completionCurr = completions && completions.find((c) => c.id === id);
    if (completionCurr.objectAssociated) {
      if (completionCurr && completionCurr.steps && completionCurr.steps[0]) {
        if (checkoutid && checkoutid !== "cancel") {
          if (
            completionCurr.steps.find((st) =>
              st.questions.find((q) => q.label === "Paybox"),
            )
          ) {
            setLoading(false);
            setCompletion(completionCurr);
          }
        } else {
          setLoading(false);
          setCompletion(completionCurr);
        }
      } else {
        navigate("/");
      }
    } else {
      initCompletion(msalInstance, variables, contactId, completionCurr)
        .then((res) => {
          if (res.ok) {
            return res.json();
          }
        })
        .then((newCandidature) => {
          if (newCandidature) {
            var completionsLoc = Object.assign([], completions);
            var index = completionsLoc.findIndex((c) => c.id === id);
            completionsLoc[index] = newCandidature;
            setCompletions(completionsLoc);
            localStorage.setItem(
              "lastCandidature",
              JSON.stringify(newCandidature.objectAssociated),
            );

            completionCurr =
              completionsLoc && completionsLoc.find((c) => c.id === id);
            if (
              completionCurr &&
              completionCurr.steps &&
              completionCurr.steps[0]
            ) {
              if (checkoutid && checkoutid !== "cancel") {
                if (
                  completionCurr.steps.find((st) =>
                    st.questions.find((q) => q.label === "Paybox"),
                  )
                ) {
                  setLoading(false);
                  setCompletion(completionCurr);
                }
              } else {
                setLoading(false);
                setCompletion(completionCurr);
              }
            } else {
              navigate("/");
            }
          }
        });
    }
  }, [
    id,
    completions,
    theme,
    navigate,
    t,
    checkoutid,
    msalInstance,
    variables,
    contactId,
    setLoading,
    setCompletions,
  ]);

  useEffect(() => {
    if (returnpaiement && returnpaiement === "paid") {
      var completionCurr = completions && completions.find((c) => c.id === id);
      var typeLoc = types?.find((t) => t.id === completionCurr?.typeId)?.name;
      var payboxQuestionId = searchParams.get("q");
      navigate("/" + typeLoc + "/" + id + "/paid", { state: { payboxQuestionId } });
    }
  }, [returnpaiement, completions, id, navigate, types, searchParams]);

  useEffect(() => {
    if (types && completion) {
      const type = types && types.find((t) => t.id === completion.typeId);
      if (type && type.filters) {
        const properties = type.filters.map((filter) => ({
          description: filter.description,
          value: completion.properties?.[filter.name],
        }));
        setPropertiesParameters(properties);
      }
    }
  }, [types, completion]);

  useEffect(() => {
    if (completion?.objectAssociated?.objectId && completion?.objectAssociated?.objectType) {
      getHistory(msalInstance, variables, completion.objectAssociated.objectType, completion.objectAssociated.objectId)
        .then(notes => {
          if (notes && Array.isArray(notes)) {
            setActivityHistory(notes);
          }
        });
    }
  }, [completion, msalInstance, variables]);
  const apiStep = completion.step ?? 0;
  const totalSteps = completion.steps?.length ?? 0;
  const isFinished = completion?.finishedInfo?.finished || (totalSteps > 0 && apiStep >= totalSteps);
  const canStillEdit = completion?.finishedInfo?.canStillEdit || false;
  const currentType = types?.find((type) => type.id === completion?.typeId);
  const typeRouteName = currentType?.name;
  const currentStepIndex = isFinished
    ? totalSteps
    : Math.max(0, Math.min(completion?.step || 0, totalSteps - 1));
  const completedStepsCount = isFinished
    ? totalSteps
    : currentStepIndex;
  const progressPercent =
    totalSteps > 0 ? Math.round((completedStepsCount / totalSteps) * 100) : 0;

  const completionSubtitle = propertiesParameters
    .filter(
      (param) =>
        param.value !== null && param.value !== "" && param.value !== undefined,
    )
    .map((param) => param.value)
    .join(" · ");

  const displayedActivity = activityHistory.slice(0, 10);

  const documentItems = (completion?.steps || []).flatMap((step, stepIdx) => {
    const isLocked = step.pipelinePrerequisite && step.pipelinePrerequisite !== completion?.hs_pipeline_stage;
    if (isLocked) return [];
    return (step?.questions || [])
      .filter((question) => question?.fieldType === "file" && question?.label)
      .map((question) => ({
        key: `${step?.id || "step"}-${stepIdx}-${question?.id || question?.label}`,
        label: question.label,
        uploaded: !!question.value,
        required: !!question.required,
      }));
  });
  const uniqueDocumentItems = documentItems
    .filter(
      (doc, index, arr) =>
        index === arr.findIndex((item) => item.label === doc.label),
    )
    .map((doc) => ({
      ...doc,
      required: documentItems.some((d) => d.label === doc.label && d.required),
      uploaded: documentItems.some((d) => d.label === doc.label && d.uploaded),
    }))
    .filter((doc) => doc.required || doc.uploaded);

  const visibleSteps = completion?.steps || [];

  // Find the highest accessible step at or below the API step value
  const redirectStepIndex = (() => {
    var apiStep = completion?.step || 0;
    var steps = completion?.steps || [];
    for (let i = Math.min(apiStep, steps.length - 1); i >= 0; i--) {
      var s = steps[i];
      if (!s.pipelinePrerequisite || s.pipelinePrerequisite === completion?.hs_pipeline_stage) {
        return i;
      }
    }
    return 0;
  })();

  const navigateToCompletion = () => {
    if (typeRouteName && completion?.id) {
      navigate("/" + typeRouteName + "/" + completion.id, { state: { targetStep: redirectStepIndex } });
    }
  };

  return (
    <div
      className={
        isVisible
          ? "my-forms-visible max-w-7xl mx-auto px-5 sm:px-8 lg:px-10 py-10"
          : "hidden"
      }
    >
      <button
        onClick={() => navigate("/")}
        className="inline-flex items-center gap-1 text-sm text-gray-400 hover:text-gray-600 transition-colors mb-6"
      >
        ← {t("Toutes mes formations")}
      </button>

      {/* Title block */}
      <div className="mb-6">
        <span className="inline-flex items-center px-3 py-1 text-[0.7rem] font-bold uppercase tracking-widest color-primary-perso border border-current" style={{ borderRadius: '11px' }}>
          {completion?.finishedInfo?.finished ? t("Candidature terminée") : t("Suivi de ma candidature")}
        </span>

        <h1 className="mt-5 mb-2 text-[clamp(1.75rem,3.5vw,2.5rem)] font-bold leading-[1.1] text-gray-900" lang="fr" translate="yes">
          {completion?.label || t("Suivi de ma candidature")}
        </h1>

        {completionSubtitle && (
          <p className="text-base leading-relaxed text-gray-500" lang="fr" translate="yes">
            {completionSubtitle}
          </p>
        )}
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-[1.15fr_minmax(340px,420px)] gap-8 xl:gap-10 items-start">
        <section className="order-last xl:order-first">
          <div className="mb-8">
            <h2 className="text-lg font-bold text-gray-900 mb-3">
              {t("Etapes")}
            </h2>
            <ul className="space-y-2.5">
              {visibleSteps.map((step, stepIdx) => {
                const isCompleted =
                  isFinished || stepIdx < completedStepsCount;
                const isCurrent =
                  !isFinished && stepIdx === currentStepIndex;
                const isLocked = !isFinished && !!(step.pipelinePrerequisite && step.pipelinePrerequisite !== completion?.hs_pipeline_stage);
                const isAccessible = !isLocked && !isFinished && stepIdx <= (completion?.step || 0);

                return (
                  <li
                    key={step.id || stepIdx}
                    className={`flex items-center gap-3${isAccessible ? " cursor-pointer hover:opacity-75 transition-opacity" : ""}`}
                    onClick={() => {
                      if (isAccessible && typeRouteName && completion?.id) {
                        navigate("/" + typeRouteName + "/" + completion.id, { state: { targetStep: stepIdx } });
                      }
                    }}
                  >
                    <span
                      className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full ${isLocked ? "bg-gray-100 text-gray-300" : isCompleted ? "text-white" : isCurrent ? "text-white" : "bg-gray-200 text-gray-400"}`}
                      style={
                        !isLocked && (isCompleted || isCurrent)
                          ? {
                            backgroundColor:
                              "color-mix(in srgb, var(--primary-color) 80%, white)",
                          }
                          : {}
                      }
                    >
                      {isLocked ? (
                        <LockClosedIcon className="h-2.5 w-2.5" aria-hidden="true" />
                      ) : isCompleted ? (
                        <CheckIcon className="h-3 w-3" aria-hidden="true" />
                      ) : (
                        <span className="text-[0.65rem] font-bold">
                          {stepIdx + 1}
                        </span>
                      )}
                    </span>

                    <span
                      className={`text-[0.95rem] text-left ${isLocked ? "text-gray-300" : isCompleted || isCurrent ? "text-gray-800" : "text-gray-400"}`}
                      lang="fr" translate="yes"
                    >
                      {step.name}
                    </span>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="border bg-white" style={{ borderRadius: '20px', borderColor: '#eceef2', boxShadow: 'rgba(16, 20, 34, 0.15) 0px 12px 30px -20px' }}>
            <div className="px-5 py-4 border-b border-gray-100">
              <h2 className="text-lg font-bold text-gray-900">
                {t("Documents à préparer")}
              </h2>
            </div>

            <div className="px-5 py-3 w-full">
              {uniqueDocumentItems.length > 0 ? (
                <ul className="divide-y divide-gray-100 w-full">
                  {uniqueDocumentItems.map((doc) => (
                    <li
                      key={doc.key}
                      className="py-2.5 flex items-center text-left justify-between gap-3 text-sm"
                    >
                      <span className="text-gray-600">{doc.label}</span>
                      <span
                        className={`font-semibold ${doc.uploaded ? "text-gray-900" : "text-gray-400"}`}
                      >
                        {doc.uploaded ? (
                          <span
                            className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-white`}
                            style={{
                              backgroundColor:
                                "color-mix(in srgb, var(--primary-color) 80%, white)",
                            }}
                          >
                            <CheckIcon className="h-3 w-3" aria-hidden="true" />
                          </span>
                        ) : (
                          t("Manquant")
                        )}
                      </span>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-500">
                  {t("Aucun document détecté")}
                </p>
              )}
            </div>
          </div>
        </section>

        <aside className="space-y-6 order-first xl:order-last">
          <div className="border bg-white p-5" style={{ borderRadius: '20px', borderColor: '#eceef2', boxShadow: 'rgba(16, 20, 34, 0.15) 0px 12px 30px -20px' }}>
            <h2 className="text-lg font-bold text-gray-900 mb-4">
              {t("Progression")}
            </h2>

            <div className="h-2 rounded-full bg-gray-100 overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${progressPercent}%`,
                  backgroundColor: "var(--primary-color)",
                }}
              />
            </div>

            <div className="mt-3 flex items-center justify-between text-sm">
              <span className="text-gray-500">
                {completedStepsCount} / {totalSteps} {t("étapes")}
              </span>
              <span className="font-bold text-gray-800">
                {progressPercent}%
              </span>
            </div>

            {!isFinished ? (<button
              onClick={navigateToCompletion}
              className="mt-5 w-full inline-flex items-center justify-center px-5 py-3 text-base font-semibold text-white hover:opacity-95 transition-opacity"
              style={{ backgroundColor: "var(--primary-color)", borderRadius: '11px' }}
            >
              {t("Poursuivre")}
            </button>) : canStillEdit && (
              <button
                onClick={navigateToCompletion}
                className="mt-5 w-full inline-flex items-center justify-center px-5 py-3 text-base font-semibold text-white hover:opacity-95 transition-opacity"
                style={{ backgroundColor: "var(--primary-color)", borderRadius: '11px' }}
              >
                {t("Éditer ma candidature")}
              </button>
            )}

          </div>

          <div className="border bg-white p-5" style={{ borderRadius: '20px', borderColor: '#eceef2', boxShadow: 'rgba(16, 20, 34, 0.15) 0px 12px 30px -20px' }}>
            <h2 className="text-lg font-bold text-gray-900 mb-4">
              {t("Historique")}
            </h2>

            {displayedActivity.length > 0 ? (
              <ul className="divide-y divide-gray-100 w-full">
                {displayedActivity.map((item) => (
                  <li key={item.id} className="py-2.5 flex items-center justify-between gap-0.5 text-sm w-full">
                    <div className="flex items-center justify-between gap-3">
                      <span className="text-gray-600 text-left">{item.label}</span>
                    </div>
                    {item.createdAt && (
                      <span className="text-xs text-gray-400">
                        {new Date(item.createdAt).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-500">
                {t("Aucun historique disponible")}
              </p>
            )}
          </div>
        </aside>
      </div>
    </div>
  );
}

export default withTranslation()(FormHomePage);
